var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0;fill:#808080;}\r\n\t.st1{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,5.6c0.2,0,0.3,0.1,0.3,0.3v11.8c0,0.2-0.1,0.3-0.3,0.3h-3.3c0,0,0,0,0,0h-5.9c0,0,0,0,0,0h-3.3 c-0.2,0-0.3-0.1-0.3-0.3V6c0-0.2,0.1-0.3,0.3-0.3H24.2 M24.2,4.6H11.8c-0.7,0-1.3,0.6-1.3,1.3v11.8c0,0.7,0.6,1.3,1.3,1.3h3.3 l5.9,0l3.3,0c0.7,0,1.3-0.6,1.3-1.3V6c0-0.4-0.1-0.7-0.4-0.9C24.9,4.8,24.6,4.6,24.2,4.6L24.2,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,9.8c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7C16.2,10.5,17,9.8,17.9,9.8  M17.9,8.8c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C20.6,10,19.4,8.8,17.9,8.8L17.9,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.3,14.2c1.3,0,2.3,1,2.3,2.3v1.6h-7.2v-1.6c0-1.3,1-2.3,2.3-2.3H19.3 M19.3,13.2h-2.7 c-1.8,0-3.3,1.5-3.3,3.3v1.6v1h1h7.2h1v-1v-1.6C22.6,14.7,21.1,13.2,19.3,13.2L19.3,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.3,21.6H10.7c-0.2,0-0.3,0.2-0.3,0.3s0.2,0.3,0.3,0.3h14.5c0.2,0,0.3-0.2,0.3-0.3S25.4,21.6,25.3,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.3,26H10.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.3,0.3h14.5c0.2,0,0.3-0.2,0.3-0.3 C25.6,26.1,25.4,26,25.3,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.3,30.4H10.7c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.3,0.3h14.5c0.2,0,0.3-0.2,0.3-0.3 C25.6,30.5,25.4,30.4,25.3,30.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.21fd7d96.svg";
export { ForwardRef as ReactComponent };